import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=f63b19e2&scoped=true&"
import script from "./NavigationList.vue?vue&type=script&lang=js&"
export * from "./NavigationList.vue?vue&type=script&lang=js&"
import style0 from "./NavigationList.vue?vue&type=style&index=0&id=f63b19e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63b19e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VTextField})
